<script lang="ts">
	import { getClient, query } from 'svelte-apollo';
	import _ from 'lodash';
	import LoadingOverlay from '../../LoadingOverlay.svelte';
	import { GET_COOKIES_QUERY } from '../../../graphql/queries/segments';

	export let confidence = 0;
	export let socDemoConfidence = 0;
	export let ageGroups = '';
	export let interestOne: string;
	export let interestTwo: string;
	export let interestsOperator: string;
	export let gender: string;
	export let newInterest: string[];
	export let newConfidence: number;
	export let income: string[];
	export let incomeConf: number;
	export let isLookalike: boolean;
	export let lookalikeConf: number;
	export let basicInterestOperator: string;

	let estimatedNumber = -1;

	let isLoading: boolean;

	const DEBOUNCE_WAIT = 1100;

	$: {
		console.log('Getting estimated numbers for:', {
			confidence,
			socDemoConfidence,
			ageGroups,
			interestOne,
			interestTwo,
			newInterest,
			newConfidence,
			interestsOperator,
			gender,
			income,
			incomeConf,
			isLookalike,
			lookalikeConf,
			basicInterestOperator
		});

		debouncedRefetch();
	}

	const parseInterest = (interestString: string) => parseInt(interestString) || 0;

	const client = getClient();

	const getVarObject = () => ({
		confidence: confidence / 100,
		socDemoConfidence: socDemoConfidence / 100,
		ageGroups,
		interestOne: parseInterest(interestOne),
		interestTwo: parseInterest(interestTwo),
		newInterest: newInterest,
		newConfidence: newConfidence / 100,
		interestsOperator,
		gender,
		income,
		incomeConf: incomeConf / 100,
		isLookalike: isLookalike,
		lookalikeConf: lookalikeConf / 100,
		basicInterestOperator: basicInterestOperator
	});
	const estimatedNumberQuery = query(client, {
		query: GET_COOKIES_QUERY,
		variables: getVarObject(),
		errorPolicy: 'all'
	});

	const refetch = async () => {
		isLoading = true;
		const response = await estimatedNumberQuery.refetch(getVarObject());

		isLoading = false;
		estimatedNumber = response.data && response.data.cookieCount;
	};

	const debouncedRefetch = _.debounce(refetch, DEBOUNCE_WAIT);
</script>

<div class="wrap">
	<LoadingOverlay absolute spinner visible={isLoading} />
	<div class="mdc-typography--headline2 number">
		<!-- {#await $estimatedNumberQuery}
            loading
        {:then number} -->
		{#if estimatedNumber === -1}loading...{:else}{new Intl.NumberFormat().format(
				estimatedNumber
			)}{/if}
		<!-- {/await} -->
	</div>
	<div class="mdc-typography--body2 description">Estimated number of cookie IDs</div>
</div>

<style>
	.wrap {
		display: flex;
		flex-direction: column;
		/* height: 100%; */
		flex: 1;
		justify-content: center;
		padding: 2rem 0;
		position: relative;
		text-align: center;
	}

	.number {
		color: var(--mdc-theme-primary);
		font-weight: bold;
		margin-bottom: 1.8rem;
	}

	.description {
		color: #adadad;
	}
</style>
